export default class CalendarMonth {

    private _year:number; //full year
    private _month:number; //0 based month

    private fromTs:number
    private toTs:number;

    public static now():CalendarMonth{
        let today = new Date();
        return new CalendarMonth(today.getFullYear(), today.getMonth());
    }

    public static fromCenturyMonth(monthFromCentury:number):CalendarMonth{
        return new CalendarMonth(1900 + Math.floor(monthFromCentury/12), monthFromCentury % 12);
    }

    constructor(year: number, month: number) {
        this._year = year;
        this._month = month;

        this.fromTs = new Date(this.year, this.month, 1,0, 0, 0).valueOf();
        this.toTs = new Date(this.year, this.month +1, 0,23, 59, 59).valueOf();

        console.log("BOUNDS", this.month, this.year, this.fromTs, this.toTs);
    }

    public containsTimestamp(ts:number){
        return (this.fromTs <= ts) && (this.toTs >= ts);
    }

    /**
     * numer dnia w miesiacu z ts lub -1 gdy to nie dzien z tego miesiaca
     * @param ts
     */
    public dayNumberInMonth(ts:number):number{

        console.log("THIS ts", ts);

        if(this.containsTimestamp(ts)){

            console.log("TIMESTAMP", ts);

            let days = ts - this.fromTs;

            console.log("TIMESTAMP", days);

            let day = Math.ceil(days / (1000 * 60 * 60 * 24));

            console.log("TIMESTAMP", day);

            return day;
        }
        return -1;
    }

    /**
     * Liczba lat od roku 1900
     */
    public monthsFromCentury():number {
        return  Math.round(this.year * 12 + this.month - (1900 * 12) );
    }

    get year(): number {
        return this._year;
    }

    get month(): number {
        return this._month;
    }

    /**
     * First week day of month 0- SUNDAY, 1 - MONDAY
     */
    public firstWeekDay():number{
        return new Date(this._year, this._month, 1).getDay();
    }

    /**
     * Number of days in month
     */
    public monthLength():number {
        return new Date(this._year, this._month + 1, 0).getDate();
    }

    public minusMonths(monthToSubtract: number):CalendarMonth{
        return this.plusMonths(-1 * monthToSubtract);
    }

    public plusMonths(monthToAdd: number): CalendarMonth {
        if(monthToAdd == 0){
            return new CalendarMonth(this._year, this._month);
        }

        let monthCount = this._year * 12 + this._month;
        let addedMonthCount = monthCount + monthToAdd;

        let newYear = Math.floor(addedMonthCount / 12);
        let newMonth = addedMonthCount - (newYear * 12);

        return new CalendarMonth(newYear, newMonth);
    }
}